export default __webpack_public_path__ + "static/google-en-e5416efb3d3b41c78ef7709578df71ce.png";